import React, { Component } from 'react';
import Cropper from 'react-easy-crop';
// import { withRouter } from 'react-router-dom';
import '../../profilePicture/index.scss';
import { withRouter } from '../../../../services/withRoute';
import LoadingBar from '../../global/loadingBar';
import TenantController from '../../../../controllers/projectsGraphQl';
import { ReactComponent as Close } from '../../../../assets/svg/cross.svg';
class Logo extends TenantController {
	constructor() {
		super();
		this.state = {
			imageSrc: null,
			crop: { x: 0, y: 0 },
			zoom: 1,
			aspect: 1 / 1,
			minus: false,
			//   file:props.files,
			active: 'white',
			isUploading: false,
		};
	}

	componentDidMount = () => {
		// this.setState({
		// 	file: this.props.files,
		// });
	};

	onCropChange = (crop) => {
		this.setState({ crop });
	};

	onCropComplete = async (croppedArea, croppedAreaPixels) => {
		var image = new Image();
		image.src = this.props.imageSrc;

		const canvas = document.createElement('canvas');
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = croppedAreaPixels.width;
		canvas.height = croppedAreaPixels.height;
		const ctx = canvas.getContext('2d');

		// New lines to be added
		const pixelRatio = window.devicePixelRatio;
		canvas.width = croppedAreaPixels.width * pixelRatio;
		canvas.height = croppedAreaPixels.height * pixelRatio;
		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		ctx.imageSmoothingQuality = 'high';

		ctx.drawImage(
			image,
			croppedAreaPixels.x * scaleX,
			croppedAreaPixels.y * scaleY,
			croppedAreaPixels.width * scaleX,
			croppedAreaPixels.height * scaleY,
			0,
			0,
			croppedAreaPixels.width,
			croppedAreaPixels.height,
		);

		canvas.toBlob((blob) => {
			let file = new File([blob], this.props.files.name, {
				type: this.props.files.type,
			});
			this.setState({
				file: file,
			});
		});
	};

	onZoomIn = () => {
		this.setState({ zoom: this.state.zoom + 0.1 });
	};
	onZoomOut = () => {
		if (this.state.zoom > 1) {
			this.setState({ zoom: this.state.zoom - 0.1 });
		} else {
			this.setState({ zoom: this.state.zoom });
		}
	};
	sortview = (type) => {
		if (type === 'm') {
			this.setState({
				minus: true,
			});
		} else {
			this.setState({
				minus: false,
			});
		}
	};
	selectbg = (k) => {
		if (k === 'w') {
			this.setState({
				active: 'white',
			});
		} else {
			this.setState({
				active: '#555',
			});
		}
	};

	uploadImage = () => {
		// this.setState({
		// 	isUploading: true,
		// });
		this.props.imgCrop(this.state.file);
		this.props.close();
		// this.uploadProfilePicture(this.state.file,this.props.addEmployeeId);
	};

	render() {
		return (
			<React.Fragment>
				<>
					<div className="new-upload-modal-container" style={{ width: '50vw' }}>
						<div className="new-upload-header">
							<span className="header-text-new">UPLOAD Profie Picture</span>
							<span className="header-close-new" onClick={(e) => this.props.close(e)}>
								<Close />
							</span>
						</div>
						<div className="new-upload-body-container" style={{ width: '100%' }}>
							<div className="new-upload-cropper-container" style={{ width: '100%' }}>
								<Cropper
									image={this.props.imageSrc}
									crop={this.state.crop}
									zoom={this.state.zoom}
									aspect={this.state.aspect}
									onCropChange={this.onCropChange}
									onCropComplete={this.onCropComplete}
									onZoomChange={this.onZoomChange}
									background={'blue'}
								/>
							</div>
						</div>
						<div className="new-upload-footer-container" style={{ width: '100%' }}>
							<div className="new-upload-scale-container">
								<span className="scale-text">Scale</span>
								<div className="scale-right-container">
									<span className="percentage-text">100%</span>
									<div className="plus-minus-container">
										<span
											className="minus-container"
											onClick={(() => this.sortview('m'), this.onZoomOut)}
										>
											-
										</span>
										<span
											className="plus-container"
											onClick={(() => this.sortview('p'), this.onZoomIn)}
										>
											+
										</span>
									</div>
								</div>
							</div>
							{this.state.isUploading ? (
								<span className="new-upload-btn loading-btn">
									<LoadingBar />
								</span>
							) : (
								<span
									className="new-upload-btn"
									onClick={() => {
										// if (!this.state.isUploading) {
										this.uploadImage();
										// }
									}}
								>
									Add Profile Picture
								</span>
							)}
						</div>
					</div>
					{/* <div className="lrBodyChild">
						<div className="leadHeader header-wrapper">
							<Plus /> Upload Logo
							<span className={'sub-text'}>
								Hi {this.props.match.params.workspaceID}, we’re excited to share
								your albums,{this.props.match.params.workspaceID}.huemn.com/
								{this.state.galleryUrl}
							</span>
							<span onClick={(e) => this.props.close(e)}>
								<Close />
							</span>
						</div>
						<div className="create-project-container" style={{ padding: '0' }}>
							<div
								className={'crop-image-container ' + this.state.c + 'active'}
								style={{ background: this.state.active }}
							>
								<Cropper
									image={this.props.imageSrc}
									crop={this.state.crop}
									zoom={this.state.zoom}
									aspect={this.state.aspect}
									onCropChange={this.onCropChange}
									onCropComplete={this.onCropComplete}
									onZoomChange={this.onZoomChange}
									background={'blue'}
								/>
							</div>
							<div className="crop-action-container w-100 f-left">
								<div className="left d-flex align-center">
									<Bulbicon />
									Drag on the image to reposition it.
								</div>
								<div className="right">
									<a
										className={this.state.minus ? 'minus active' : 'minus'}
										onClick={(() => this.sortview('m'), this.onZoomOut)}
									>
										{this.state.minus ? <Minuscoloricon /> : <Minusicon />}
									</a>
									<a
										className={this.state.minus ? 'plus' : 'plus active'}
										onClick={(() => this.sortview('p'), this.onZoomIn)}
									>
										{this.state.minus ? <Plusicon /> : <Pluscoloricon />}
									</a>
								</div>
							</div>
							<div className="w-100 f-left select-bg-container">
								<h4 className="w-100 f-left">Logo Background</h4>
								<a
									className={
										this.state.active === '#555'
											? 'box white-box'
											: 'box white-box active'
									}
									onClick={() => this.selectbg('w')}
								>
									<span>Light</span>
								</a>
								<a
									className={
										this.state.active === 'white'
											? 'box dark-box'
											: 'box dark-box active'
									}
									onClick={() => this.selectbg('d')}
								>
									<span>Dark</span>
								</a>
								<h5 className={'w-100 f-left'}>
									Choose between a light or dark theme that best suits your logo
								</h5>
							</div>
							<div className="w-100 f-left button-container crop-btn-container">
								<Button
									classname={'primary-button'}
									name={'Upload Logo'}
									isLoading={this.state.isUploading}
									onClick={() => this.uploadImage()}
								/>
							</div>
						</div>
					</div> */}
				</>
			</React.Fragment>
		);
	}
}

export default withRouter(Logo);
